/**
 * The container for product tiles on brand search section
 */
import { ProductTileClickImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileViewImpressionProvider";
import { BrandSearchContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchContext";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React, { useContext } from "react";

export const BrandSearchProductTileTrackingContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { searchString, requestId } = useContext(BrandSearchContext);
  return (
    <ProductTileViewImpressionProvider
      context={`${ProductTileContainer.SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND}|${searchString}`}
      requestId={requestId}
      screenContext={ProductTileScreen.SEARCH_PRODUCT_RESULTS}
      containerContext={
        ProductTileScreenContainer.SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND_PRODUCTS
      }
      contextToken={searchString}
    >
      <ProductTileClickImpressionProvider
        context={`${ProductTileContainer.SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND}|${searchString}`}
        requestId={requestId}
        screenContext={ProductTileScreen.SEARCH_PRODUCT_RESULTS}
        containerContext={
          ProductTileScreenContainer.SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND_PRODUCTS
        }
        contextToken={searchString ?? ""}
        productTileContainer={
          ProductTileContainer.SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND
        }
      >
        {children}
      </ProductTileClickImpressionProvider>
    </ProductTileViewImpressionProvider>
  );
};
